import React, { Component } from "react";
import PropTypes from "prop-types";

export default class ArchiveRadioGroupFilter extends Component {
    constructor(props) {
        super(props);
    }

    renderOptions() {
        return this.props.options.map(option => {
            return (
                <div className="filter__option-wrapper" key={option.value}>
                    <input
                        type="radio"
                        className="filter__field checkbox-style"
                        id={option.value}
                        name={this.props.id}
                        value={option.value}
                        checked={this.props.value === option.value}
                        onChange={e => this.props.onChanged(e)}
                    />
                    <label htmlFor={option.value}>{option.name}</label>
                </div>
            );
        });
    }

    render() {
        return (
            <section className="filter">
                <h4 className="filter__title">{this.props.title}</h4>
                <fieldset
                    className="filter__container filter__checkbox-group"
                    method="get"
                >
                    {this.renderOptions()}
                </fieldset>
            </section>
        );
    }
}

ArchiveRadioGroupFilter.props = {
    options: PropTypes.array,
    title: PropTypes.string,
    id: PropTypes.string
};
